import {container, singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {ArrayHelper} from "../../helpers/array.helper";
import {TransformerHelper} from "../../helpers/transformer.helper";
import {Repository} from "../../persistence/repository";
import {Employee} from "../entities/employee.entity";
import {WeeklyWorkingTimeRepository} from "./weekly-working-time.repository";

@singleton()
@persistence({entity: Employee, preload: true})
export class EmployeeRepository extends Repository<Employee> {

    public async create(): Promise<Employee> {
        const employee = new Employee();
        employee.lastName = ``;
        employee.firstName = ``;
        employee.weeklyWorkingTime = container.resolve(WeeklyWorkingTimeRepository).create(employee);

        return Promise.resolve(employee);
    }

    public async findOneByFullName(lastName: string, firstName: string): Promise<Employee | null> {
        const DTOs = await this.entityManager.findAllByQueryParameters(Employee.name, [
            {
                key: `firstName`,
                comparator: `eq`,
                value: firstName,
            },
            {
                key: `lastName`,
                comparator: `eq`,
                value: lastName,
            },
        ]);

        if (DTOs.length < 1) {
            return null;
        }

        return TransformerHelper.fromDTO(ArrayHelper.first(DTOs)!, Employee);
    }
}